import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Breadcrumb } from '@fikasio/react-ui-components';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import AddTemplateButton from 'components/templates/AddTemplateButton';
import TemplatesView from 'components/templates/TemplatesView';
import BasePage from 'components/UI/BasePage';
import { useGetTemplatesQuery } from 'services/templates/api';
import links from 'utils/links';
import { spaLinkProps } from 'utils/spaLink';

const TemplatesPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data: templates } = useGetTemplatesQuery();

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t('templates')}</title>
      </Helmet>
      <BasePage>
        <Breadcrumb
          items={[
            { ...spaLinkProps(links.paths.home, navigate), label: t('home') },
            { ...spaLinkProps(links.timesheet(), navigate), label: t('timesheet') },
            { label: t('templates') },
          ]}
        />
        <AddTemplateButton
          style={{
            float: 'right',
          }}
        />
        <h4>{t('templates')}</h4>
        <br />
        <TemplatesView
          templates={templates}
        />
      </BasePage>
    </>
  );
};

export default TemplatesPage;
